import { render } from "./MatchComponent.vue?vue&type=template&id=295eb6ec"
import script from "./MatchComponent.vue?vue&type=script&lang=js"
export * from "./MatchComponent.vue?vue&type=script&lang=js"

import "./MatchComponent.vue?vue&type=style&index=0&id=295eb6ec&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__